import commonUtil from './../../../utils/commonUtil';

export const CONTENT_LOAD = 'CONTENT_LOAD';
export const CONTENT_LOAD_SUCCESS = 'CONTENT_LOAD_SUCCESS';
export const CONTENT_LOAD_FAIL = 'CONTENT_LOAD_FAIL';

export function isContentLoaded(globalState) {
  return globalState.targetterContent && globalState.targetterContent.loaded;
}

// export function loadContent() {
//   return {
//     types: [CONTENT_LOAD, CONTENT_LOAD_SUCCESS, CONTENT_LOAD_FAIL],
//     promise: client => client.get('/api/targetterContent'), // params not used, just shown as demonstration
//   };
// }

export function loadContent() {
  const _targetterInput = {};
  _targetterInput.brand = commonUtil.getBrand();
  _targetterInput.channel = commonUtil.getChannel();
  _targetterInput.requiredTargeters = ['MainBannerTargeter', 'VideoTargeter', 'CelebrationEventDetailTargeter', 'TipoDeEventDetailTargeter', 'CelebrationsTypeTargeter', 'OpenTypeTargeter', 'StepsOfEventCreationTargeter', 'EventToolsTargeter', 'BannerImageTargeter', 'OffersTargeter', 'InspirationPageForEventTargetter', 'homePageMenuForLoggedInUser', 'homePageMenuForLoggedOutUser', 'EventToolsGuestBannerContent_Web', 'EventToolsGuestBannerContent_Wap'];
  return {
    types: [CONTENT_LOAD, CONTENT_LOAD_SUCCESS, CONTENT_LOAD_FAIL],
    promise: client => client.post('/api/targetterContent', {
      data: (_targetterInput),
    }), // params not used, just shown as demonstration
  };
}
